import React, { useState, useEffect } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';
import { navigate } from 'gatsby';
import PageTemplate from '../UI/PageTemplate/pageTemplate';
import Loading from '../General/Loading';
import Container from '../General/Container';
import MotionLoading from '../UI/MotionLoading/motionLoading';
import BamAdvice from './BamAdvice';
import ContactService from '../../services/Contact';
import { GoogleTagManager } from '../../helpers';
import MarketplaceService from '../../services/Marketplace';

const ConsejosBam = () => {
  const [data, setData] = useState({
    support: {
      days: [''],
      phoneNumber: '',
      start: '',
      finish: '',
      enabled: false,
    },
  });
  const [loading, showLoading] = useState(true);
  const [error, showError] = useState(false);
  const [par] = useQueryParam('par', StringParam);

  const loadData = () => {
    if (par) {
      MarketplaceService.getRemoveWelcomeBundleBAM();
      navigate('/consejos-bam');
    }

    showLoading(true);
    ContactService.getContactData()
      .then(res => {
        const [contactData] = res;
        const { contact } = contactData;
        setData(contact);
      })
      .catch(() => {
        showError(true);
      })
      .then(() => {
        showLoading(false);
      });
  };
  useEffect(() => {
    loadData();

    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/consejos-bam',
      pagename: 'Consejos BAM',
    });
  }, []);

  return (
    <PageTemplate seo="Consejos BAM">
      {loading && (
        <Container>
          <Loading />
        </Container>
      )}
      <MotionLoading loading={loading}>
        {!loading && (
          <BamAdvice contactData={data.support} contactError={error} />
        )}
      </MotionLoading>
    </PageTemplate>
  );
};

export default ConsejosBam;
